module.exports = __webpack_public_path__ + "img/friend16.905cf9d8.png";